import Transitions from '@noction/vue-bezier'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(Transitions)
})